import { associations, Relation } from "@nozbe/watermelondb";
import { field, json, relation, text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";
import DocketTemplateType from "./DocketTemplateType";
import { noopSanitizeJSON } from "../utils";
import { DocketFilter } from "@towersystems/roam-common/lib/generated-types";

export default class DocketTemplate extends BaseModel {
  static table = "docket_templates";

  static associations = associations([
    "docket_template_types",
    { type: "belongs_to", key: "default_template_type_id" },
  ]);

  @text("name") name: string;

  @relation("docket_template_types", "default_template_type_id")
  defaultTemplateType: Relation<DocketTemplateType>;

  @field("enabled") enabled: boolean;

  @json("filters", noopSanitizeJSON) filters: DocketFilter[];

  @json("terminal_ids", noopSanitizeJSON) terminalIds:
    | string[]
    | null
    | undefined;

  @field("automatically_print") automaticallyPrint: boolean;
}
